import { useFeatureConfigUI } from '@/hooks/query/useFeatureConfig';
import { useResponsiveConstants } from '@/hooks/responsive/useResponsiveConstants';
import { usePreview } from '@/hooks/usePreview';

export const useShowFullScreenItem = () => {
  const isPreview = usePreview();
  const { mobile } = useResponsiveConstants();
  const { feature } = useFeatureConfigUI('doc_full_screen_view');

  return !mobile && !isPreview && feature;
};
